"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationApprovalPanelHeader = exports.RegistrationApprovalPanelBody = void 0;

var _preact = require("preact");

var _Switcher = _interopRequireDefault(require("../../preact-components/control/Switcher"));

var _PanelItems = require("./PanelItems");

var _Message = require("../ui-components/Message");

var _ExternalLink = require("../ui-components/ExternalLink");

var _PanelHeaderWithIcon = require("../ui-components/PanelHeaderWithIcon");

var RegistrationApprovalPanelBody = function RegistrationApprovalPanelBody(_ref) {
  var isRegistrationApprovalEnabled = _ref.isRegistrationApprovalEnabled,
      showRegistrationApprovalActionButtons = _ref.showRegistrationApprovalActionButtons,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onRegistrationApprovalChanged = _ref.onRegistrationApprovalChanged;
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)(_Message.Message, {
    text: "By default, new registered users can create topics and reply after they activated their account."
  }), (0, _preact.h)("div", null, (0, _preact.h)(_Switcher.default, {
    on: isRegistrationApprovalEnabled,
    customClass: "panel-switch",
    label: "New registered users must be approved by moderators. A user can only create topics and reply after approval.",
    onChange: function onChange() {
      return onRegistrationApprovalChanged(!isRegistrationApprovalEnabled);
    }
  })), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to approve new registrations",
    url: "https://community.insided.com/registration-login-preferences-sso-88/how-to-enable-moderator-approval-of-new-registrations-501"
  }), showRegistrationApprovalActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    }
  }));
};

exports.RegistrationApprovalPanelBody = RegistrationApprovalPanelBody;

var RegistrationApprovalPanelHeader = function RegistrationApprovalPanelHeader(_ref2) {
  var statusText = _ref2.statusText;
  return (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
    customClass: "panel-header-container",
    iconCustomClass: "icon-panel-header",
    icon: "checkUserRegistration",
    title: "Registration approvals",
    statusText: statusText
  });
};

exports.RegistrationApprovalPanelHeader = RegistrationApprovalPanelHeader;